import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Activity } from "lucide-react";

export const GatewayHealthBadge = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["gateway-health"],
    queryFn: async () => (await api.get("/brokers/sharekhan/gateway-health")).data,
    retry: false,
  });
  const label = isLoading ? "Checking…" : !data?.configured ? "Not configured (no connection attempted)"
    : data.contract_ok ? `Healthy · mTLS verified · order routes blocked (${data.target})`
    : `Check failed [${data.category || "unknown"}]: ${data.detail || "unknown"}${data.target ? ` (${data.target})` : ""}`;
  const tone = data?.contract_ok ? "text-emerald-400" : data?.configured ? "text-rose-400" : "text-slate-400";
  return (
    <div data-testid="gateway-health-badge" className="flex items-center gap-2 rounded-md border border-[var(--border-subtle)] px-3 py-2 text-xs">
      <Activity className="w-3.5 h-3.5 text-slate-500" />
      <span className="text-slate-400">Sharekhan gateway:</span>
      <span data-testid="gateway-health-status" className={tone}>{label}</span>
    </div>
  );
};
